/*import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./BlogPost.css";

function BlogPost() {
    const { id } = useParams(); // Obtiene el ID del blog desde la URL
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        fetch(BACKEND_URL + `/api/blogs/${id}`)
            .then((response) => response.json())
            .then((data) => setBlog(data))
            .catch((error) => console.error("Error al cargar el blog:", error));
    }, [id]);

    if (!blog) {
        return <p className="loading">Cargando contenido del blog...</p>;
    }

    return (
        <div className="blog-post-container" translate="no">
            <h2>{blog.title}</h2>
            <p className="blog-date">Publicado el: {new Date(blog.createdAt).toLocaleDateString()}</p>
            <img src={blog.image} alt={blog.title} className="blog-image-large" />
            <p className="blog-content">{blog.content}</p>
        </div>
    );
}

export default BlogPost;*/

import BlogPostHero from "./BlogPostHero";
import BlogPostDetails from "./BlogPostDetails";
import StructuredData from "../seo/StructuredData";
import Waves from "../../blocks/Backgrounds/Waves/Waves";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import TheQAHubAcademyImage from "../../images/TheQAHubAcademy.png";
import { useTranslation } from "../../i18n";
import { fetchJsonFromApiCandidates } from "../../utils/api";
import { getLocalizedBlog } from "../../utils/localizedBlog";
import { findFallbackBlogById, isFallbackBlog } from "../../utils/fallbackBlogs";
import { blogPostingSchema, breadcrumbSchema, organizationSchema, schemaGraph } from "../../utils/seoData";
import "./BlogPost.css";

function BlogPost() {
    const { language, t } = useTranslation();
    const { id } = useParams(); // Obtiene el ID del blog desde la URL
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        if (isFallbackBlog(id)) {
            setBlog(findFallbackBlogById(id));
            return;
        }

        fetchJsonFromApiCandidates(`/api/blogs/${id}`)
            .then(({ data }) => setBlog(data || findFallbackBlogById(id)))
            .catch((error) => {
                console.error("Error al cargar el blog:", error);
                setBlog(findFallbackBlogById(id));
            });
    }, [id]);

    if (!blog) {
        return <p className="loading">{t("blogPost.loading")}</p>;
    }

    const localizedBlog = getLocalizedBlog(blog, language);

    return (
        <div>
            <StructuredData
                data={schemaGraph([
                    organizationSchema(TheQAHubAcademyImage),
                    blogPostingSchema({
                        id: blog._id,
                        title: localizedBlog.title,
                        summary: localizedBlog.summary,
                        content: localizedBlog.content,
                        image: blog.image,
                        date: blog.createdAt,
                    }),
                    breadcrumbSchema([
                        { name: "Inicio", url: "/" },
                        { name: "Blog", url: "/blog" },
                        { name: localizedBlog.title, url: `/blog/${blog._id}` },
                    ]),
                ])}
            />
            <BlogPostHero image={blog.image} backgroundPosition={blog.backgroundPosition}/>
            <div className="waves-section">
                <Waves 
                    lineColor="#97b79e" 
                    backgroundColor="transparent" 
                    waveSpeedX={0.02}
                    waveSpeedY={0.005}
                    waveAmpX={25}
                    waveAmpY={10}
                    xGap={12}
                    yGap={20}
                    className="custom-waves"
                />
                <p className="waves-text">{t("blogPost.waves")}</p>
            </div>
            <BlogPostDetails
                title={localizedBlog.title}
                content={localizedBlog.content}
                summary={localizedBlog.summary}
                date={blog.createdAt}
                postId={blog._id}
                initialComments={blog.comments}
                isStaticPost={isFallbackBlog(blog)}
            />
        </div>
    );
}

export default BlogPost;
